import { useEffect } from 'react';
import { ROUTES } from 'constants/index.js';
import { generatePath, useNavigate, useSearchParams } from 'react-router-dom';
import { useAppContext } from 'services/context';
import { USER_ACTIONS, LANGAUGE_ACTIONS } from 'services/reducers/actionTypes';
import { useSessionStorage } from 'services/hooks';
import { isUserLanguageValid } from 'services/utils';

const SilentLogin = () => {
	//u -> email
	//p -> password
	//r -> recordId
	//t -> target

	//http://localhost:3000/app/SILENT_LOGIN?u=jirogo5746@haboty.com&p=z9z799PK&t=review&r=[recordId]
	const { dispatchUser, Api, setLang } = useAppContext();
	let [searchParams, setSearchParams] = useSearchParams();

	const navigate = useNavigate();
	const [_, setCacheUser] = useSessionStorage('user', '');

	useEffect(() => {
		async function login(userName, password, target) {
			const loggedInUser = await Api.Login({ userName, password });
			if (loggedInUser && !loggedInUser.unauthorized) {
				dispatchUser({ type: USER_ACTIONS.LOG_IN, payload: loggedInUser });
				setCacheUser(loggedInUser);

				if (loggedInUser?.preferredLanguageId && isUserLanguageValid(loggedInUser?.preferredLanguageId))
					setLang({ type: LANGAUGE_ACTIONS.CHANGE_LANG, languageId: loggedInUser?.preferredLanguageId });

				const route = ROUTES[target.toUpperCase()];
				const path = generatePath(`${route}/:recordId`, {
					recordId: r,
				});
				navigate(path, { replace: true });
				return;
			}
			navigate(ROUTES.LOGIN, { replace: true });
		}

		const u = searchParams.get('u');
		const p = searchParams.get('p');
		const r = searchParams.get('r');
		const t = searchParams.get('t');

		if (!u || !p || !t || !r) return;
		login(u, p, t);
	}, []);

	return null;
};

export default SilentLogin;
